'use client';

import { useLayoutEffect } from 'react';
import { mountAnalyticsConsent } from '@/lib/privacy/analytics-client';

export function FirebaseAnalyticsBootstrap() {
  useLayoutEffect(mountAnalyticsConsent, []);
  return null;
}
